import type { PromptBundleWriteRequest } from "contracts/api/prompts/requests";
import {
  PromptBundleListResponseSchema,
  PromptBundleSchema,
} from "contracts/api/prompts/responses";
import { request } from "./api-client";

// The yeet-agent is the only prompt surface today; the API is surface-scoped
// so keep the segment explicit rather than hiding it behind a default.
const SURFACE = "yeet-agent";

export const promptsApi = {
  listBundles: () =>
    request(
      "GET",
      `/api/prompts/${SURFACE}/bundles`,
      PromptBundleListResponseSchema,
    ),
  getBundle: (id: string) =>
    request("GET", `/api/prompts/bundles/${id}`, PromptBundleSchema),
  activeBundle: () =>
    request("GET", `/api/prompts/${SURFACE}/active`, PromptBundleSchema),
  createBundle: (input: PromptBundleWriteRequest) =>
    request(
      "POST",
      `/api/prompts/${SURFACE}/bundles`,
      PromptBundleSchema,
      input,
    ),
  forkBundle: (id: string, input: PromptBundleWriteRequest) =>
    request("PUT", `/api/prompts/bundles/${id}`, PromptBundleSchema, input),
  activateBundle: (bundleId: string) =>
    request("POST", `/api/prompts/${SURFACE}/activate`, PromptBundleSchema, {
      bundleId,
    }),
};
